import { Grid2 } from "@mui/material";

// Empty grid placeholder so BasicLayout can compute the row alignment
// the same way as in Mails. We don't expose actions yet; restore is
// not available from the Teams API.
export const plusActionsGrid = {
  xl: 12,
  lg: 12,
  md: 12,
  sm: 12,
  xs: 12,
};

const PlusActions = () => {
  return <Grid2 container {...{ size: 0 }} />;
};

export default PlusActions;
